import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, cx } from 'emotion';
import { from, until } from '@guardian/src-foundations/mq';
const hideBelowDesktop = css `
	${until.desktop} {
		/* below 980 */
		display: none;
	}

	${from.desktop} {
		/* above 980 */
		height: 100%;
		display: block;
		flex-basis: 300px;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;
export const RightColumn = ({ children }) => {
    return _jsx("section", Object.assign({ className: cx(hideBelowDesktop) }, { children: children }), void 0);
};
